import { render } from "./IssueArticleDetails.vue?vue&type=template&id=38df56ca&scoped=true"
import script from "./IssueArticleDetails.vue?vue&type=script&lang=js"
export * from "./IssueArticleDetails.vue?vue&type=script&lang=js"

import "./IssueArticleDetails.vue?vue&type=style&index=0&id=38df56ca&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3595080301/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38df56ca"]])

export default __exports__